export interface ILabel {
    id?: string;
    name: string;
    colour: string;
    type: ELabelType;
}

export enum ELabelType {
    OrderBoard = 'order_board',
    Action = 'action',
}
